import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['checkbox', 'archiveButton', 'toggleCheckboxes'];

  connect() {
    this.updateArchiveButton();
  }

  onCheckboxChange() {
    this.updateArchiveButton();
  }

  setCheckboxValues(value) {
    this.checkboxTargets.forEach(checkbox => {
      if (checkbox.disabled) return;
      checkbox.checked = value;
    });
  }

  updateArchiveButton() {
    const hasChecked = this.checkboxTargets.some(checkbox => checkbox.checked);
    this.archiveButtonTarget.disabled = !hasChecked;
  }

  toggleCheckboxes() {
    this.setCheckboxValues(this.toggleCheckboxesTarget.checked);
    this.updateArchiveButton();
  }

  confirmArchive(event) {
    const count = this.checkboxTargets.filter(checkbox => checkbox.checked).length;
    const message = `Are you sure you want to archive the ${count} selected line item${count !== 1 ? 's' : ''}?`;

    // eslint-disable-next-line no-alert
    if (!window.confirm(message)) {
      event.preventDefault();
    }
  }
}
